<div class="container">
    <!-- <div class="info-text subtitle1">Select at least one user group from the following:</div> -->
    <div class="search-container">
        <mat-form-field appearance="fill" class="searchbox">
            <input id="searchInput" matInput [ngModel]="searchInput" (keyup)="search($event.target.value)"
                placeholder="Search...">
        </mat-form-field>
        <button mat-raised-button class="search-icon-container" color="primary"><img alt="search"
                src="assets/icons/search.svg" (click)="search(searchInput)"></button>
    </div>
    <div class="filter-options">
        <!-- <div class="title header3">User Groups</div> -->
        <div class="filter-container">
            <div class="filter-icon-holder">
                <img style="vertical-align:bottom; padding-right: 8px" src="assets/icons/filter.svg" alt="filter">
                <span class="subtitle3">Filter
                    By</span>
            </div>
            <div class="filter-inputs">
                <mat-form-field class="form" appearance="fill">
                    <mat-label>Region</mat-label>
                    <input type="text" matInput aria-label="Number" [formControl]="regionFilterControl"
                        id="regionFilter" [matAutocomplete]="region" [(ngModel)]="regionFilter">
                    <button mat-button *ngIf="regionFilter" matSuffix mat-icon-button aria-label="Clear"
                        (click)="filter('Region', '')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-autocomplete #region="matAutocomplete"
                        (optionSelected)='filter("Region", $event.option.value)'>
                        <mat-option *ngFor="let option of regionSearchValues" [value]="option.Region">
                            {{option.Region}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>Zone</mat-label>
                    <input type="text" matInput aria-label="Number" [formControl]="zoneFilterControl" id="zoneFilter"
                        [matAutocomplete]="zone" [(ngModel)]="zoneFilter">
                    <button mat-button *ngIf="zoneFilter" matSuffix mat-icon-button aria-label="Clear"
                        (click)="filter('Zone', '')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-autocomplete #zone="matAutocomplete" (optionSelected)="filter('Zone', $event.option.value)">
                        <mat-option *ngFor="let option of zoneSearchValues" [value]="option.Zone">
                            {{option.Zone}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>District</mat-label>
                    <input type="text" matInput aria-label="Number" [formControl]="districtFilterControl"
                        id="districtFilter" [matAutocomplete]="district" [(ngModel)]="districtFilter">
                    <button mat-button *ngIf="districtFilter" matSuffix mat-icon-button aria-label="Clear"
                        (click)="filter('District', '')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-autocomplete #district="matAutocomplete"
                        (optionSelected)="filter('District', $event.option.value)">
                        <mat-option *ngFor="let option of districtSearchValues" [value]="option.District">
                            {{option.District}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <button mat-button class='clear-filters-btn' (click)="clearFilters()">Clear Filters</button>
            </div>
        </div>

    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    <div class="table-container">
        <app-data-table [displayedColumns]="columns" [tableData]="dealers" [initSortColumn]="0" [component]="this"
            [initSortDirection]="'asc'" [selectable]="true" [selection]="selection"></app-data-table>
        <div class="not-found-container" *ngIf="entityId && dealers.length == 0">
            <!-- <mat-icon class="error-icon">error_outline</mat-icon>  -->
            <h4>No dealers found</h4>
        </div>
    </div>
    <div class="chip-list">
        <mat-chip-list>
            <mat-chip *ngFor="let group of selection.selected" [removable]="true" class="selected-chip"
                (removed)="removeSelectedGroup(group)">
                {{group.name}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>
</div>